module.exports = __webpack_public_path__ + "img/it-support-feishu.5a7aac3c.png";